<template>
  <div class="header">
    <div class="header-left">
      <img class="logo-img" src="@/assets/images/logo.png" alt="" />
      <div class="logo-text">航天联志智能制造系统(IMS) V.1.2</div>
    </div>
    <div class="header-right">
      <div
        class="header-right-ionic"
        v-if="
          menuPath.includes('/product/Category') ||
            menuPath.includes('/product')
        "
      >
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="two-menu-box"
        >
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/product/Category')"
            @click="goUrl('productCategory', 1)"
          >
            <svg-icon iconClass="chanpinxian" className="menuIcon"></svg-icon>
            产品线
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/product')"
            @click="goUrl('product', 1)"
          >
            <svg-icon
              iconClass="chanpinxinghao"
              className="menuIcon"
            ></svg-icon>
            产品型号
          </p>
          <div
            slot="reference"
            class="menu-item"
            :class="menuIndex == 1 ? 'active-menu' : ''"
          >
            <svg-icon
              iconClass="chanpin"
              className="menuIcon"
              fillcolor="#ffffff"
            ></svg-icon>
            产品
          </div>
        </el-popover>
      </div>
      <div
        class="header-right-ionic"
        v-if="
          menuPath.includes('/component') ||
            menuPath.includes('/component/group')
        "
      >
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="two-menu-box"
        >
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/component')"
            @click="goUrl('component', 2)"
          >
            <svg-icon iconClass="wuliaoguanli" className="menuIcon"></svg-icon>
            物料
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/component/group')"
            @click="goUrl('componentGroup', 2)"
          >
            <svg-icon iconClass="wuliaofenzu" className="menuIcon"></svg-icon>
            物料分组
          </p>
          <div
            slot="reference"
            class="menu-item"
            :class="menuIndex == 2 ? 'active-menu' : ''"
          >
            <svg-icon
              iconClass="wuliaoxilie"
              className="menuIcon"
              fillcolor="#ffffff"
            ></svg-icon>
            物料
          </div>
        </el-popover>
      </div>
      <div
        class="header-right-ionic"
        v-if="
          menuPath.includes('/requirement') ||
            menuPath.includes('/requirement/config')
        "
      >
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="two-menu-box"
        >
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/requirement')"
            @click="goUrl('requirement', 6)"
          >
            <svg-icon iconClass="wuliaoguanli" className="menuIcon"></svg-icon>
            需求提交
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/requirement/config')"
            @click="goUrl('requirementConfig', 6)"
          >
            <svg-icon iconClass="wuliaofenzu" className="menuIcon"></svg-icon>
            配置方案
          </p>
          <div
            slot="reference"
            class="menu-item"
            :class="menuIndex == 6 ? 'active-menu' : ''"
          >
            <svg-icon
              iconClass="wuliaoxilie"
              className="menuIcon"
              fillcolor="#ffffff"
            ></svg-icon>
            需配
          </div>
        </el-popover>
      </div>
      <div
        class="header-right-ionic menu-item"
        v-if="menuPath.includes('/quotation')"
        :class="menuIndex == 3 ? 'active-menu' : ''"
        @click="goUrl('quotationList', 3)"
      >
        <svg-icon
          iconClass="baojiadan"
          className="menuIcon"
          fillcolor="#ffffff"
        ></svg-icon>
        报价
      </div>
      <div
        class="header-right-ionic"
        v-if="
          menuPath.includes('/quotation/approval') ||
            menuPath.includes('/plan/pick-material') ||
            menuPath.includes('/plan/produce') ||
            menuPath.includes('/plan/initial-inspection') ||
            menuPath.includes('/plan/preburning') ||
            menuPath.includes('/plan/final-inspection') ||
            menuPath.includes('/plan/package') ||
            menuPath.includes('/plan/transport')
        "
      >
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="two-menu-box"
        >
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/quotation/approval')"
            @click="goUrl('examine', 4)"
          >
            <svg-icon iconClass="shenhe" className="menuIcon"></svg-icon>
            审核
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/pick-material')"
            @click="goUrl('picking', 4)"
          >
            <svg-icon iconClass="lingliao" className="menuIcon"></svg-icon>
            领料
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/produce')"
            @click="goUrl('productionAssembly', 4)"
          >
            <svg-icon
              iconClass="shengchanzhuangpei"
              className="menuIcon"
            ></svg-icon>
            生产装配
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/initial-inspection')"
            @click="goUrl('newInspect', 4)"
          >
            <svg-icon iconClass="chujian" className="menuIcon"></svg-icon>
            初检
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/preburning')"
            @click="goUrl('oldInspect', 4)"
          >
            <svg-icon iconClass="laohua" className="menuIcon"></svg-icon>
            老化
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/final-inspection')"
            @click="goUrl('endInspect', 4)"
          >
            <svg-icon iconClass="zhongjian" className="menuIcon"></svg-icon>
            终检
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/package')"
            @click="goUrl('package', 4)"
          >
            <svg-icon iconClass="baozhuang" className="menuIcon"></svg-icon>
            包装
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/plan/transport')"
            @click="goUrl('logistics', 4)"
          >
            <svg-icon iconClass="wuliu" className="menuIcon"></svg-icon>
            物流
          </p>
          <div
            slot="reference"
            class="menu-item"
            :class="menuIndex == 4 ? 'active-menu' : ''"
          >
            <svg-icon
              iconClass="zhizao"
              className="menuIcon"
              fillcolor="#ffffff"
            ></svg-icon>
            智造
          </div>
        </el-popover>
      </div>
      <div
        class="header-right-ionic"
        v-if="menuPath.includes('/productReport')"
      >
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="two-menu-box"
        >
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/productReport')"
            @click="goUrl('productReport', 6)"
          >
            <svg-icon iconClass="setMonth" className="menuIcon"></svg-icon>
            生产月报管理
          </p>
          <div
            slot="reference"
            class="menu-item"
            :class="menuIndex == 1 ? 'active-menu' : ''"
          >
            <svg-icon
              iconClass="month"
              className="menuIcon"
              fillcolor="#ffffff"
            ></svg-icon>
            生产月报
          </div>
        </el-popover>
      </div>
      <div class="header-right-ionic">
        <el-popover
          placement="bottom"
          trigger="hover"
          popper-class="two-menu-box"
        >
          <p class="two-menu-item" @click="changePassword">
            <svg-icon iconClass="xiugaimima" className="menuIcon"></svg-icon>
            修改密码
          </p>
          <p class="two-menu-item" @click="goUrl('personalAssets', 5)">
            <svg-icon iconClass="gerenzichan" className="menuIcon"></svg-icon>
            个人资产
          </p>
          <p
            class="two-menu-item"
            v-if="menuPath.includes('/user')"
            @click="goUrl('user', 5)"
          >
            <svg-icon iconClass="yonghuguanli" className="menuIcon"></svg-icon>
            用户管理
          </p>
          <p
            class="two-menu-item"
            v-if="usertype == 0"
            @click="goUrl('system', 5)"
          >
            <svg-icon iconClass="xitongpeizhi" className="menuIcon"></svg-icon>
            配置管理
          </p>
          <p
            class="two-menu-item"
            v-if="usertype == 0"
            @click="goUrl('role', 5)"
          >
            <svg-icon iconClass="jueseguanli" className="menuIcon"></svg-icon>
            角色管理
          </p>
          <p
            class="two-menu-item"
            v-if="usertype == 0"
            @click="goUrl('log', 5)"
          >
            <svg-icon iconClass="rizhi" className="menuIcon"></svg-icon>
            日志
          </p>
          <div
            slot="reference"
            class="menu-item"
            :class="menuIndex == 5 ? 'active-menu' : ''"
          >
            <svg-icon
              iconClass="user"
              className="menuIcon"
              fillcolor="#ffffff"
            ></svg-icon>
            {{ nickname }}
          </div>
        </el-popover>
      </div>
      <div class="header-right-ionic" @click="goUrl('login', 5)">
        <img class="ionic" src="@/assets/images/icon5.png" alt="" />
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="showPasswordChange"
      width="400px"
      :before-close="closePasswordChange"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="passwordForm"
        size="mini"
        :inline="true"
        :rules="rules"
        :model="passwordForm"
        class="demo-form-inline"
      >
        <el-form-item label="原密码:" prop="oldPassword" label-width="120px">
          <el-input v-model="passwordForm.oldPassword" auto-complete="off" />
        </el-form-item>
        <el-form-item label="新密码:" prop="newPassword" label-width="120px">
          <el-input v-model="passwordForm.newPassword" auto-complete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePasswordChange">取消</el-button>
        <el-button type="primary" @click="savePasswordChange">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { passwordChange } from "@/api/product";

export default {
  name: "headNav",
  data() {
    return {
      usertype: this.$store.state.usertype,
      menuIndex: "5",
      nickname: this.$store.state.nickname,
      menuPath: this.$store.state.menuPath
        ? this.$store.state.menuPath.split(",")
        : [],
      showPasswordChange: false,
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ]
      },
      passwordForm: {}
    };
  },
  methods: {
    changePassword() {
      this.showPasswordChange = true;
    },
    savePasswordChange() {
      const that = this;
      this.$refs["passwordForm"].validate(valid => {
        if (valid) {
          passwordChange(this.passwordForm)
            .then(response => {
              that.$refs["passwordForm"].resetFields();
              that.passwordForm = {};
              that.$message.success("修改成功");
              that.showPasswordChange = false;
              that.$router.push({ path: "/login" });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    closePasswordChange() {
      this.passwordForm = {};
      this.$refs["passwordForm"].resetFields();
      this.showPasswordChange = false;
    },
    goUrl(url, num) {
      this.menuIndex = num;
      this.$router.push({
        name: url
      });
    }
  },
  mounted() {
    if (
      this.$route.path == "/product/Category" ||
      this.$route.path == "/product"
    ) {
      this.menuIndex = 1;
    } else if (
      this.$route.path == "/component" ||
      this.$route.path == "/component/group"
    ) {
      this.menuIndex = 2;
    } else if (
      this.$route.path == "/quotation" ||
      this.$route.path == "/quotation/detail"
    ) {
      this.menuIndex = 3;
    } else if (
      this.$route.path == "/examine" ||
      this.$route.path == "/picking" ||
      this.$route.path == "/productionAssembly" ||
      this.$route.path == "/newInspect" ||
      this.$route.path == "/oldInspect" ||
      this.$route.path == "/endInspect" ||
      this.$route.path == "/package" ||
      this.$route.path == "/logistics"
    ) {
      this.menuIndex = 4;
    } else if (
      this.$route.path == "/user" ||
      this.$route.path == "/personalAssets" ||
      this.$route.path == "/system"
    ) {
      this.menuIndex = 5;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  height: 80px;
  display: flex;
  padding: 0 100px;
  justify-content: space-between;
  background-color: #951d1d;
  align-items: center;
  color: #ffffff;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    background-color: #951d1d;
    top: 80px;
    left: 0;
  }

  .header-left {
    display: flex;
    align-items: center;

    .logo-img {
      height: 30px;
      width: 120px;
      margin-right: 15px;
    }

    .logo-text {
      font-size: 18px;
      margin-top: 3px;
      letter-spacing: 3px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .header-right-ionic {
      cursor: pointer;
      margin: 0 15px;

      .ionic {
        width: 15px;
        height: 15px;
      }
    }

    .menu-item {
      display: flex;
      align-items: center;
      .menuIcon {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
      @media only screen and (max-width: 1350px) {
        .menuIcon {
          display: none;
        }
      }
    }

    .active-menu {
      //display: inline-block;
      padding: 5px 10px;
      color: #fff;
      font-size: 15px;
      text-decoration: none;
      background-color: #ff3333; /* 白色背景 */
      border-radius: 5px; /* 按钮圆角 */
      box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2); /* 按钮阴影 */
      transition: all 0.5s ease; /* 添加过渡效果，使按钮变化更平滑 */
    }
  }
}

.dialog-footer {
  text-align: center;
}

.two-menu-box {
  .two-menu-item {
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #cccccc;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .menuIcon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headNav.vue